import { parsePhoneNumber } from 'libphonenumber-js';

export default function PhoneFormat(phoneNumber: string) {
	if (!phoneNumber || !phoneNumber.length) return '';
	const phoneNumberObj = parsePhoneNumber(`+${phoneNumber}`);
	return phoneNumberObj.formatInternational();
}
